import { API } from "aws-amplify";
import { updateMembershipStatus, joinCircle, joinEvent } from "@/graphql/mutations";
import { sendRecommendToUser } from "@/hooks/useRecommendation";
import { UtilsUsecase } from "./types";

const statusAlternative = {
  DECLINED: "DENIED",
  ACCEPTED: "APPROVED",
};

export async function circleEventInviteUsecase(payload: any, utils: UtilsUsecase) {
  try {
    await API.graphql({
      query: updateMembershipStatus,
      variables: {
        ...payload?.invite,
        status: statusAlternative?.[payload?.purpose as never],
      },
    });

    await utils.refetch();

    if (payload?.purpose === "ACCEPTED") {
      if (payload?.type === "EVENT") {
        utils.successModal({
          show: true,
          title:
            payload?.privacy === "PUBLIC"
              ? `Congrats!`
              : `Congrats! You have now joined the Event.`,
          body:
            payload?.privacy === "PUBLIC"
              ? `You have now joined the ${payload?.contextName} Event.`
              : `You have joined ${payload?.contextName}.`,
        });
      } else {
        utils.successModal({
          show: true,
          title:
            payload?.privacy === "PUBLIC"
              ? `Congrats!`
              : `Congrats! You have now joined the Circle.`,
          body:
            payload?.privacy === "PUBLIC"
              ? `You have now joined the ${payload?.contextName} Circle.`
              : `You have joined ${payload?.contextName}.`,
        });
      }
    } else {
      if (payload?.type === "EVENT") {
        utils.successModal({
          show: true,
          title: `Event Declined`,
          body: `You have successfully declined the invitation to this Event.`,
        });
      } else {
        utils.successModal({
          show: true,
          title: `Circle Declined`,
          body: `You have successfully declined the invitation to join this Circle.`,
        });
      }
    }
  } catch (error: any) {
    utils.errorModal({
      title: "Error",
      body:
        error?.errors?.[0]?.message ||
        `${payload?.purpose?.toLocaleLowerCase()} invitation failed, please try again.`,
      show: true,
      type: "error",
    });
  }
}

export async function circleEventRecommendationUsecase(payload: any, utils: UtilsUsecase) {
  try {
    if (payload?.type === "CIRCLE") {
      if (payload?.purpose === "ACCEPTED") {
        await API.graphql({
          query: joinCircle,
          variables: {
            circleId: payload?.id,
          },
        });
        await utils.refetch();
        utils.successModal({
          show: true,
          title:
            payload?.privacy === "PUBLIC"
              ? `Congrats!`
              : `Confirmed Request to Join a Private Circle`,
          body:
            payload?.privacy === "PUBLIC"
              ? `You have successfully joined a Circle.`
              : `Your request to join  this circle is pending approval by the organizers. You'll be notified if your request is approved.`,
        });
      } else {
        await sendRecommendToUser({
          purpose: "DECLINED",
          type: payload?.type,
          typeID: payload?.notificationId,
        });
        await utils.refetch();
        utils.successModal({
          show: true,
          title: `Circle Recommendation Declined`,
          body: `You have successfully declined the circle recommendation.`,
        });
      }
    } else {
      if (payload?.purpose === "ACCEPTED") {
        await API.graphql({
          query: joinEvent,
          variables: {
            eventId: payload?.id,
          },
        });
        await utils.refetch();
        utils.successModal({
          show: true,
          title:
            payload?.privacy === "PUBLIC"
              ? `Congrats!`
              : `Confirmed Request to Join a Private Event`,
          body:
            payload?.privacy === "PUBLIC"
              ? `You have successfully joined an Event.`
              : `Your request to join this event is pending approval by the organizers. You'll be notified if your request is approved.`,
        });
      } else {
        await sendRecommendToUser({
          purpose: "DECLINED",
          type: payload?.type,
          typeID: payload?.notificationId,
        });
        await utils.refetch();
        utils.successModal({
          show: true,
          title: `Event Recommendation Declined`,
          body: `You have successfully declined the event recommendation.`,
        });
      }
    }
  } catch (error: any) {
    if (payload?.type === "CIRCLE") {
      if (payload?.purpose === "ACCEPTED") {
        utils.errorModal({
          title: "Join circle Error",
          body:
            error?.errors?.[0]?.message ||
            "There was a problem joining the circle, please try again. Join circle failed",
          show: true,
          type: "error",
        });
      } else {
        utils.errorModal({
          show: true,
          title: `Decline Circle Error`,
          body:
            error?.errors?.[0]?.message ||
            "There was a problem declining the circle, please try again. Decline circle failed",
          type: "error",
        });
      }
    } else {
      if (payload?.purpose === "ACCEPTED") {
        utils.errorModal({
          title: "Join event Error",
          body:
            error?.errors?.[0]?.message ||
            "There was a problem joining the event, please try again. Join event failed",
          show: true,
          type: "error",
        });
      } else {
        utils.errorModal({
          show: true,
          title: `Decline Event Error`,
          body:
            error?.errors?.[0]?.message ||
            "There was a problem declining the event, please try again. Decline event failed",
          type: "error",
        });
      }
    }
  }
}

